module.exports = __webpack_public_path__ + "img/unpublished-24px.20995677.svg";